import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	ai_answer_card_collapse_button: {
		id: 'search_ai.ai_answer_card_collapse_button',
		defaultMessage: 'Collapse',
		description: 'Text for the smart answer card "Collapse" button',
	},
	ai_answer_card_expand_button: {
		id: 'search_ai.ai_answer_card_expand_button',
		defaultMessage: 'Expand',
		description: 'Text for the smart answer card "Expand" button',
	},
	ai_answer_card_tab_ai_answer: {
		id: 'search_ai.ai_answer_card_tab_ai_answer',
		defaultMessage: 'AI Answer',
		description: 'Text for the smart answer card "AI answer" tab',
	},
	ai_answer_card_tab_sources: {
		id: 'search_ai.ai_answer_card_tab_sources',
		defaultMessage: 'Sources',
		description: 'Text for the smart answer card "Sources" tab',
	},
	ai_answer_card_tab_sources_with_pluralization: {
		id: 'search_ai.ai_answer_card_tab_sources_with_pluralization',
		defaultMessage: '{sourcesCount, plural, one {Source} other {Sources {sourcesCount}}}',
		description: 'Text for the smart answer card "Sources" tab with pluralization',
	},
	ai_answer_card_read_more_button: {
		id: 'search_ai.ai_answer_card_read_more_button',
		defaultMessage: 'Read more',
		description: 'Text for the smart answer card "Read more" button',
	},
	ai_answer_card_show_more_button: {
		id: 'search_ai.ai_answer_card_show_more_button',
		defaultMessage: 'Show more',
		description: 'Text for the smart answer card "Show more" button',
	},
	ai_answer_open_chat_input_box_ask_rovo: {
		id: 'search_ai.ai_answer_open_chat_input_box_ask_rovo',
		defaultMessage: 'Ask Rovo anything',
		description: 'Placeholder text for input box',
	},
});
